/**
 * onChangeRaw may be triggered by either the text input or a calendar click.
 * Calendar events do not necessarily expose a string value on currentTarget.
 */
export const datePickerRawValue = (event: any): string | null => {
  const value = event?.currentTarget?.value ?? event?.target?.value
  return typeof value === 'string' ? value : null
}
